import { render, staticRenderFns } from "./agentArea.vue?vue&type=template&id=06a0d7fe&scoped=true&"
import script from "./agentArea.vue?vue&type=script&lang=js&"
export * from "./agentArea.vue?vue&type=script&lang=js&"
import style0 from "./agentArea.vue?vue&type=style&index=0&id=06a0d7fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a0d7fe",
  null
  
)

export default component.exports